<template>
  <div>
    <div class="line__vertical-mains"></div>
    <sub-header :micrositeUrl="micrositeUrl" />
    <!-- <button-back/>  -->
    <div v-if="locations.length > 0" class="map_filter">
      <div class="maphighlight__box">
          <h1 class="caption__select">
                  <span>Seleccione una casa, clic para ver detalles</span>
                </h1>
        <map-highlight v-for="(img, index) in imgSet" :key="index" :index="index" :img="img"
                       :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :type="type"
                       :nivel="nivel"/>
        <Button v-for="(img, index) in imgSet" :key="img.width" :index="index" :img="img" :id="id"
                :desarrollo="desarrollo" :nivel="nivel" :levelId="levelId" :url="url"/>
        <div class="line_horizontal"></div>
        <Availables
            v-if="rangeFilterPrice[0] !== null && rangeFilterPrice[1] !== null"
            class="availables-mobile"
            :type="type"
            :existFilter="existFilter"
            @onUpdateModel="updateActiveModel"
            :desarrollo="desarrollo"
            :filterPrice="rangeFilterPrice"
        /> 
      </div>
      <div class="select__box">
        <Availables
            v-if="rangeFilterPrice[0] !== null && rangeFilterPrice[1] !== null"
            class="availables-desk"
            :type="type"
            :desarrollo="desarrollo"
            :existFilter="existFilter"
            @onUpdateModel="updateActiveModel"
            :filterPrice="rangeFilterPrice"
        />
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import MapHighlight from "../../../core/MapHighlight";
import SubHeader from "../../../core/SubHeader.vue";
//import ButtonBack from "../../../core/ButtonBack";
import Button from "../../../core/Button.vue";
import Availables from "../../../core/Availables.vue";

export default {
  name: "Main",
  components: {
    MapHighlight,
    Button,
    SubHeader,
    /* ButtonBack, */
    Availables
  },
  data() {
    return {
      id: 23,
      levelId: 66,
      type: "casas",
      desarrollo: "bosques_casas",
      micrositeUrl: "https://www.tresmarias.com.mx/bosques/casas",
      arrFilteredLocations: [],
      nivel: "availability",
      url: `bosques_casas/detalles`,
      imgSet: [
        {
          name: 'bosques_casas',
          url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/bosques/Bosques_casas-lotes.png',
          width: '908',
          height: '1206',
          id: 23,
          levelId: 66,
          route: 'bosques_casas/detalles',
          nivel: 'availability',
          transform: '',
          viewBox: '0 0 908 1206'
        }
      ],
      // si no hay filtro volver rangeFilter a false
      rangeFilter: false,
      activeModel: "",
      rangeFilterPrice:[null,null],
    };
  },
  computed: {
    ...mapGetters({
      locations: "getLocations",
      filterModelos: "getStatusFilterModelos"
    }),
    development() {
      return {id: this.id, level: this.levelId};
    },
    amountAvailables() {
      const filteredAvailables = this.existFilter;
      const newArrfiltered = filteredAvailables.filter(
          (item) => item.status == 2
      );
      return newArrfiltered;
    },
    existFilter() {
      return this.locations
    },
  },
  methods: {
    ...mapActions(["getAvailableLocations", "clearCoords", "getFilterModelos"]),
    changeRange(arrFilter) {
      this.arrFilteredLocations = arrFilter;
    },
    updateActiveModel(model) {
      this.getFilterModelos(model);
    }
  },
 async created() {
    await this.getAvailableLocations(this.development);
    this.getFilterModelos(this.existFilter)
  },
  async beforeDestroy() {
    await this.clearCoords();
  },
  mounted() {
  },
  watch: {
    locations(newVal) {
      if (newVal.length > 0) {
        const prices = newVal
          .map(item => item.value);

        if (prices.length > 0) {
          this.rangeFilterPrice = [Math.floor(Math.min(...prices)), Math.ceil(Math.max(...prices))];
        } else {
          this.rangeFilterPrice = [null, null];
        }
        this.getFilterModelos(newVal);
      }
    }
  }
};
</script>
